export default __webpack_public_path__ + "static/media/settings_thumb.88a2ea6d.png";